import type { UiCommand } from '../services/adriApi';

export const ALLOWED_COMMAND_TYPES = ['ui.navigate', 'ui.highlight', 'ui.guide'] as const;

export const KNOWN_ROUTE_PREFIXES = [
  '/servicios',
  '/cajas',
  '/reservas',
  '/clientes',
  '/empleados',
  '/almacen',
  '/onboarding',
  '/reportes',
  '/mi-cuenta',
  '/ayuda',
  '/estadisticas',
  '/marketing',
  '/proveedores',
  '/ordenes-compra',
  '/locales',
  '/roles',
  '/comisiones',
  '/comandas',
  '/analitica',
  '/facturacion',
  '/fidelizacion',
];

const TARGET_ID_RE = /^[a-z0-9][a-z0-9._-]{0,59}$/i;
const TARGET_SELECTOR_RE = /^\[data-testid="([^"]+)"\]$/;

export const isSafeRoute = (route: unknown): boolean => {
  if (typeof route !== 'string' || !route.startsWith('/')) return false;
  if (route.startsWith('//') || route.includes('\\') || /^[a-z][a-z0-9+.-]*:/i.test(route)) {
    return false;
  }
  if (route.includes('//') || route.includes('..')) return false;
  const path = route.split(/[?#]/)[0];
  return KNOWN_ROUTE_PREFIXES.some((p) => path === p || path.startsWith(p + '/'));
};

/** Acepta id plano o selector `[data-testid="id"]` del contrato. */
export const isSafeTarget = (target: unknown): boolean => {
  if (typeof target !== 'string') return false;
  const m = TARGET_SELECTOR_RE.exec(target);
  return TARGET_ID_RE.test(m ? m[1] : target);
};

export const isSafeCommand = (cmd: unknown): cmd is UiCommand => {
  if (!cmd || typeof cmd !== 'object') return false;
  const c = cmd as Partial<UiCommand>;
  if (!ALLOWED_COMMAND_TYPES.includes(c.type as (typeof ALLOWED_COMMAND_TYPES)[number])) {
    return false;
  }
  if (c.route !== undefined && !isSafeRoute(c.route)) return false;
  if (c.routePrefix !== undefined && !isSafeRoute(c.routePrefix)) return false;
  if (c.target !== undefined && !isSafeTarget(c.target)) return false;

  switch (c.type) {
    case 'ui.navigate':
      return c.route !== undefined;
    case 'ui.highlight':
      return c.target !== undefined;
    case 'ui.guide':
      return (
        Array.isArray(c.steps) &&
        c.steps.length > 0 &&
        c.steps.every((s) => s && isSafeTarget(s.target))
      );
    default:
      return false;
  }
};
